import { PaymentSystemLogo } from '../ui/PaymentSystemLogo/PaymentSystemLogo.ts';

export const mapCardBrandBySlug = (slug = '') => {
  return (
    {
      humo: <PaymentSystemLogo.HumoLight />,
      mastercard: <PaymentSystemLogo.MastercardLight />,
      mir: <PaymentSystemLogo.MirLight />,
      visa: <PaymentSystemLogo.VisaLight />,
    }[slug] ?? <PaymentSystemLogo.BankCardFull />
  );
};
